let router = [
    {
        path: '/order/orderlist',
        name: 'orderlist',
        component: () => import('@/views/order/index.vue'),
        meta: {keepAlive: true, parentPath: 'order'},
    },
    {
        path: '/order/edit',
        name: 'orderedit',
        component: () => import('@/views/order/edit.vue'),
        meta: {keepAlive: true, parentPath: 'order'},
    },
    {
        path: '/order/evaluation',
        name: 'evaluation',
        component: () => import('@/views/order/evaluation.vue'),
        meta: {keepAlive: true, parentPath: 'order'},
    },
    {
        path: '/order/aftersales',
        name: 'aftersales',
        component: () => import('@/views/order/aftersales/index.vue'),
        meta: {keepAlive: true, parentPath: 'order'},
    },
    {
        path: '/order/aftersales/details',
        name: 'details',
        component: () => import('@/views/order/aftersales/details.vue'),
        meta: {keepAlive: true, parentPath: 'order'},
    }
    

    
    
]
export default router


// WEBPACK FOOTER //
// ./src/router/order.js